// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__25Yof","left-container":"styles_left-container__3nGiX","right-container":"styles_right-container__2ZlRC"};